// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root___8NoQ","row":"ProcedureTreatmentSummary_row__2OS-o"};